<!-- route5Verification.page.html -->
<ion-header>
    <ion-toolbar color="primary">
        <ion-title data-test="title">Route Verification</ion-title>
        <ion-buttons slot="end">
            <ion-button data-test="centerButton" (click)="onCenterMeClick()">
                <ion-icon name="locate"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <app-google-map
        [dealershipCoordinate]="dealershipCoordinate"
        [initialZoom]="14"
        [mapId]="'SHUTTLE_ROUTE_MAP'"
        [showCenterButton]="true"
        (mapReady)="onMapReady()"
        (mapError)="onMapError($event)">
    </app-google-map>

    <ion-fab vertical="bottom" horizontal="end">
        <ion-fab-button [disabled]=vb.disabled title="Next" (click)="onNextClick()" data-test="routeNext5">
            <ion-icon name="chevron-forward"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-content>
